import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'projects',
  initialState: { projects: [], selected: [], firstLoad: true },
  reducers: {
    setProjects: (state, { payload: obj }) => {
      if (obj && obj.data) {
        state.projects = obj.data;
        if (state.projects && state.projects.length > 0 && state.firstLoad) {
          state.selected = state.projects.map((p) => p.uuid);
        }
        state.firstLoad = true;
      }
    },
    addSelectedProject: (state, { payload: uuid }) => {
      if (state.selected.indexOf(uuid) <= -1) {
        state.selected.push(uuid);
      }
    },
    removeSelectedProject: (state, { payload: uuid }) => {
      const index = state.selected.indexOf(uuid);
      if (index > -1) {
        state.selected.splice(index, 1);
      }
    },
    setSelectedProjects: (state, { payload: obj }) => {
      state.selected = obj;
    },
    selectAllProjects: (state) => {
      state.selected = state.projects.map((p) => p.uuid);
    },
    deselectAllProjects: (state) => {
      state.selected = [];
    },
  },
});

export const {
  setProjects,
  setSelectedProjects,
  addSelectedProject,
  removeSelectedProject,
  selectAllProjects,
  deselectAllProjects,
} = slice.actions;

export default slice.reducer;

export const selectProjects = (state) => state.projects.projects;
export const selectedProjects = (state) => state.projects.selected;
